// Login API
export const REAL_MS = "/realms";
export const CANVAS_AI = "/canvasai";
export const PROTOCOL = "/protocol";
export const OPENID_CONNECT = "/openid-connect";
export const TOKEN = "/token";
export const KEYCLOAK = "/keycloak";
export const CONTROL_PLANE_SERVICE = "/controlplaneservice";
export const REVOKE = "/revoke";

// Landing Page API
export const LOGIN = "/login";
export const USER = "/user";
export const UNITS = "/units";

// Assistants Page API
export const APPLY_UNIT_FILTER = "&applyUnitFilter=";
export const APPLY_UNIT_FILTER_QUERY = "?applyUnitFilter=";

export const ASSISTATNTS = "/assistants";
export const ASSISTANT = "/assistant";

// Digital Employee API
export const DE_BASE_QUERY = "?limit=&page=&searchText=";
export const ORIGIN_TYPE = "&originType=";
export const STUDIO_ORIGIN = "studio";
export const LIST_DIGITAL_EMPLOYEE = "&listDigitalEmployee=";

// Agents Page API
export const AGENT = "/agent";
export const PROCESS = "/process";
export const AUTH_USER_ID = "?authServerId=";
export const CLAP = "/clap";
export const FLOW = "/flow";
export const TYPES = "/types";

//Routes constants
export const ASSISTANTS = "/assistants";
export const PROCESSES = "/processes";
export const AGENTS = "/agents";
export const MYTEAM = "/myteam";
export const DISCOVER = "/discover";
export const RAGS = "/rags";
export const COUNT = "/count";
export const DOCUMENTATION = "/documentation/Marketplace/";

//Videos
export const VIDEO_SERVICE = "/video-service";
export const VIDEO_THUMBNAIL = "/video-thumbnail";
export const VIDEOS = "/videos";
export const GENERATE_HLS = "/generate-hls";
export const VIDEO = "?video=";
export const USERID = "&user_id=";
export const CANVASAI_INTRO_VIDEO = "/demovideo";
//Discover
export const START_INDEX = "?startIndex=";
export const SEARCH_TEXT = "?searchText=";
export const LIMIT = "&limit=";
export const ORIGIN = "&origin=";
export const ORIGIN_QUERRY = "?origin=";
export const OFFSET = "&offset=";
export const AUTHORIZED = "/authorized";
export const ENTITY_ID = "&entityId=";
export const ENTITY_ID_QUERRY = "?entityId=";
export const REFRESH = "/refresh";
export const DOWNLOAD = "/download";
export const FILTER = "/filter";
export const EXPLORE = "/explore";
export const SEARCH = "/search";

//units
export const ORIGIN_VALUE = "gallery";

//rags
export const USER_ID_PARAMS = "?userId=";
export const RAG = "/rag";

export const SOURCE = "?source=";
export const ASSETS = "/assets";
export const SPACENAME = "?spaceName=";
export const ASSISTANT_NAME = "&assistantName=";
export const DIGITAL_EMPLOYEE = "/digitalemployee";
export const HIRE_DETAILS = "/hiring-details";
export const DIGITAL_PROFILE = "/digital-profile";
export const MY_TEAM = "/myteam";
export const DIGITAL_PROFILES = "/digital-profiles";
export const USER_EMAIL = "?user_email=";

export const ASSISTANT_ID = "?assistant_id=";
export const ASSISTANT_ID_PATH = "?assistantId=";
export const FEEDBACK = "/feedback";
export const TEACH = "/teach";
export const AUTH_USER_ID_AND = "&authServerId=";
export const HLS_USER_ID = "user_id=";
